import React, { useState, useRef } from 'react';
import styles from '../Assets/StorySection.module.css';
import EventVideo from "../Assets/img/event/video-event.mp4";
import EventImgOne from "../Assets/img/event/event-img1.webp";
import EventImgTwo from "../Assets/img/event/event-img2.webp";
import VideoBanner from "../Assets/img/event/video-banner.webp";
import Slider from "react-slick";
import { Container } from 'react-bootstrap';
import { BsArrowRight } from "react-icons/bs";
import { IoLocationOutline } from "react-icons/io5";
import { PiFlowerLight } from "react-icons/pi";
import { IoCameraOutline } from "react-icons/io5";
import { IoMusicalNotesOutline } from "react-icons/io5";
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { useTranslation } from 'react-i18next';

const StorySection = () => {
    const { t } = useTranslation();
    const [isPlaying, setIsPlaying] = useState(false);
    const videoRef = useRef(null);

    const handleTogglePlay = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            } else {
                videoRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: true,
            },
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: true,
            },
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                infinite: false, 
            },
        },
    ],
};

    return (
        <section className={styles.sectionWrapper}>
            <Container fluid className="home-showcase-container" style={{maxWidth:"100%", padding:'0px'}}>
                <div className={styles.gridContainer}>
                    <Slider {...settings}>
                        {/* --- LEFT CARD --- */}
                        <div className={styles.card}>
                            <img src={EventImgOne} alt="Sunset proposal setup" className={styles.cardBgImage} />
                            <div className={styles.leftOverlay} />

                            <div className={styles.cardContent + " " + styles.cardContentOne}>
                                <div className={styles.brandHeader}>
                                    <span className={styles.brandHeaderLine}>
                                        {t('storySection.leftBrandHeader')}
                                    </span>
                                </div>

                                <h2 className={styles.mainTitle}>
                                    {t('storySection.leftTitle')}{' '}
                                    <span className={styles.italicAccent}>
                                        {t('storySection.leftTitleItalic')}
                                    </span>
                                </h2>

                                <p className={styles.description}>
                                    {t('storySection.leftDescription')}
                                </p>

                                <Link to="/events-proposal">
                                    <button className={styles.ctaButton}>
                                        <span>{t('storySection.ctaButton')}</span>
                                        <span className={styles.ctaArrow}><BsArrowRight /></span>
                                    </button>
                                </Link>
                            </div>
                        </div>

                        {/* --- CENTER VIDEO CARD --- */}
                        <div className={`${styles.card} ${styles.videoCard}`}>
                            <video
                                ref={videoRef}
                                className={styles.videoPlayer}
                                src={EventVideo}
                                poster={VideoBanner}
                                onClick={handleTogglePlay}
                                loop
                                playsInline
                            />
                            {!isPlaying && (
                                <button
                                    className={styles.playOverlay}
                                    onClick={handleTogglePlay}
                                    aria-label="Play video"
                                >
                                    <div className={styles.playTriangle} />
                                </button>
                            )}
                        </div>

                        {/* --- RIGHT CARD --- */}
                        <div className={styles.card + " " + styles.cardTwo}>
                            <img src={EventImgTwo} alt="Beach proposal setup" className={styles.cardBgImage} />
                            <div className={styles.rightOverlay} />

                            <div className={styles.cardContent}>
                                <div>
                                    <p className={styles.plannerName}>
                                        {t('storySection.plannerName')}
                                    </p>
                                    <p className={styles.plannerRole}>
                                        {t('storySection.plannerRole')}
                                    </p>
                                </div>

                                <h2 className={styles.mainTitle}>
                                    {t('storySection.rightTitle')}{' '}
                                    <span className={styles.italicAccent}>
                                        {t('storySection.rightTitleItalic')}
                                    </span>
                                </h2>

                                <p className={styles.description}>
                                    {t('storySection.rightDescription')}
                                </p>

                                <ul className={styles.featureList}>
                                    <li className={styles.featureItem}>
                                        <div className={styles.iconCircle}>
                                            <IoLocationOutline />
                                        </div>
                                        <span className={styles.featureText}>
                                            {t('storySection.feature1')}
                                        </span>
                                    </li>

                                    <li className={styles.featureItem}>
                                        <div className={styles.iconCircle}>
                                            <PiFlowerLight />
                                        </div>
                                        <span className={styles.featureText}>
                                            {t('storySection.feature2')}
                                        </span>
                                    </li>

                                    <li className={styles.featureItem}>
                                        <div className={styles.iconCircle}>
                                            <IoCameraOutline />
                                        </div>
                                        <span className={styles.featureText}>
                                            {t('storySection.feature3')}
                                        </span>
                                    </li>

                                    <li className={styles.featureItem}>
                                        <div className={styles.iconCircle}>
                                            <IoMusicalNotesOutline />
                                        </div>
                                        <span className={styles.featureText}>
                                            {t('storySection.feature4')}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Slider>
                </div>
            </Container>
        </section>
    );
};

export default StorySection;